import type { ControlWidth } from '@packages/core';

import { rem } from '../../tokens/spacing';

/** CSS max-width tokens for micro-layout (control shell inside a grid cell). */
export const CONTROL_WIDTH_CSS: Record<ControlWidth, string> = {
  auto: '100%',
  short: rem(128),
  medium: rem(224),
  long: rem(360),
  full: '100%',
};

export function isBoundedControlWidth(controlWidth: ControlWidth): boolean {
  return controlWidth !== 'auto' && controlWidth !== 'full';
}
